import { Avatar, Container, Grid } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import React from "react";
import { Link } from "react-router-dom";
import brandlogo from "../assets/logo192.png";
import Footer from "./Footer";

const useStyles = makeStyles((theme) => ({
  large: {
    width: theme.spacing(15),
    height: theme.spacing(15),
  },
  contentCenter: {
    justifyItems: "normal",
  },
}));

function AboutUs() {
  const classes = useStyles();
  return (
    <Container>
          <Container>
            <Avatar src={brandlogo} alt="brand-logo" variant="square" className={classes.large} />
          </Container>
        <Container>
          <Link to="#">Open-Source License</Link>
        </Container>
        <Footer typograpy="subtitle2" />
    </Container>
  );
}

export default AboutUs;
